export default __webpack_public_path__ + "static/media/Etape10_LaMaraichere1.a398ab4b.jpg";